import { AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild, inject } from '@angular/core';
import { ApiService } from '../../../../../shared/services/api.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { Router, RouterLink } from '@angular/router';
import { CommonService } from '../../../../../shared/services/common.service';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { FormControl, FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject, finalize, catchError, debounceTime, distinctUntilChanged, filter, map, merge, of, Subject, Subscription, switchMap, takeUntil } from 'rxjs';
import { MatSort } from '@angular/material/sort';
import { IAProposalData, WorkOrderExtension } from '../../../../../shared/models/IAProposal';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { PreviewfileComponent } from '../../../previewfile/previewfile.component';
//import { MatDialog } from '@angular/material/dialog';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { RowUpdateService } from '../../../../../shared/services/row-update.service';


@Component({
  selector: 'app-verify-proposal',
  templateUrl: './verify-proposal.component.html',
  styleUrl: './verify-proposal.component.css'
})


export class VerifyProposalComponent implements OnInit, AfterViewInit, OnDestroy {
  [x: string]: any;
  private loadWOESubscription: Subscription = new Subscription();
  private loadDataSubscription: Subscription = new Subscription();
  private destroy$: Subject<void> = new Subject<void>();

  dataSource!: MatTableDataSource<IAProposalData>
  displayedColumns: string[] = ['Sr.No', 'createdProposalId', 'shortNameOfOrganisation', 'dateOfSubmission', 'interventionName', 'componentName', 'targetMSME', 'approvedTargetMSME', 'balanceTargetMSME', 'fromDate', 'toDate', 'status', 'statusDate', 'iaid', 'WorkOrderExtension', 'Download', 'Proposal', 'remarks']

  dataSourceWorkOrderExtension!: MatTableDataSource<WorkOrderExtension>
  displayedWorkOrderExtensionColumns: string[] = ['Sr.No', 'workOrderExtenstionId', 'fromDate', 'toDate', 'remark', 'workorder']
  //rp//displayedColumns: string[] = ['Sr.No', 'createdProposalId', 'shortNameOfOrganisation', 'dateOfSubmission', 'interventionName', 'componentName','targetMSME', 'status', 'statusDate','iaid', 'Download', 'Proposal', 'remarks']

  @ViewChild(MatPaginator) pagination!: MatPaginator;
  @ViewChild(MatPaginator) paginationWOE!: MatPaginator;
  @ViewChild('woePopup') woePopup!: TemplateRef<any>;
  @ViewChild(MatSort) sort!: MatSort;
  term$ = new BehaviorSubject<string>('');
  codeSearch$ = new BehaviorSubject<any>(null);
  nameSearch$ = new BehaviorSubject<any>(null);
  searchText: string = '';
  codeSearchKey: string = '';
  nameSearchKey: string = '';

  verifyProposalForm: FormGroup;
  workOrderExtForm!: FormGroup;
  fileUrl: string | null = null;
  fileName: string = ''; // Store file name separately
  uploadError: string | null = null;
  certificateFile: File | null = null;
  totalRegistered: number = 0;
  pendingVerification: number = 0;
  approvedRegistration: number = 0;
  rejectedRegistration: number = 0;
  rejectedForQueryRegistration: number = 0;
  allrecord: any[] = [];
  //dataSource: any[] = []; // Your full data source
  sortedItems: any[] = [];
  length: number = 0;
  pageSize: number = 20;
  totalItems: number = 0; // Example total items
  currentPage: number = 1;
  sortColumn: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  itemsPerPage: number = 10;
  pageSizeOptions: number[] = [10, 20, 50, 100];  // Available page sizes
  isSubmitted = false;
  data: any = {};
  UniqueEventId: any;
  proposalId: any;
  loadingSequence: boolean = false;
  isViewMode: boolean = false;
  rowUpdatedSubscription: Subscription | any;
  
  //page = 1;
  DtoPaginationWOE = {
    "PageNumber": 1,
    "PageSize": 10,
    "SortColumn": "",
    "SortDirection": "ASC",
    "SearchTerm": "",
    "SearchCol": "",
    "proposalUserId": "",
  }
  
  DtoPagination =
    {
      "PageNumber": 1,
      "PageSize": 10,
      "SortColumn": "",
      "SortDirection": "",
      "SearchTerm": "",
      "SearchCol": ""
    }

  constructor(private fb: FormBuilder, private datePipe: DatePipe, private apiService: ApiService, private toastrService: ToastrService, public dialog: MatDialog,
    private router: Router, public commonService: CommonService, private rowUpdateService: RowUpdateService) {
    //this.verifyProposalForm = new FormGroup({
    //  search: new FormControl('')
    //});
    this.verifyProposalForm = this.fb.group({
      search: new FormControl(''),
    });
    this.workOrderExtForm = this.fb.group({
      createdProposalId: [{ value: '', disabled: true }],
      shortNameOfOrganisation: [{ value: '', disabled: true }],
      interventionName: [{ value: '', disabled: true }],
      interestName: [{ value: '', disabled: true }],
      balanceTargetMSME: [{ value: '', disabled: true }],
      fromDate: [null, Validators.required],
      toDate: [null, Validators.required],
      fileUpload: [null, Validators.required],
      remark: [null, Validators.required]
    });
  }  

  //ngOnInit(): void {
  //  this.DtoPagination.PageSize = 20
  //  this.DtoPagination.SearchCol = this.commonService.searchText;
  //  this.LoadDetails();
  //}
  async ngOnInit(): Promise<void> {
    this.DtoPagination.PageSize = 20;
    this.DtoPagination.SearchTerm = this.commonService.searchText;
    //this.LoadDetails();
  }

  ngAfterViewInit() {
    if (!this.sort) {
      console.error("MatSort is not initialized!");
      return;
    }
    this.rowUpdatedSubscription = this.rowUpdateService.rowUpdated.subscribe(
      async () => {
        this.LoadDetails();
      });
    this.LoadDetails();
  }


  LoadDetails() {
    if (!this.pagination) return;
    this.loadingSequence = true;
    // Unsubscribe from previous subscription to prevent multiple API calls
    this.loadDataSubscription.unsubscribe();

    // Reset subscription with a new request
    this.loadDataSubscription = merge(
      this.sort.sortChange.pipe(takeUntil(this.destroy$)),
      this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
      this.pagination.page.pipe(takeUntil(this.destroy$))
    )
      .pipe(
        finalize(() => {
          this.loadingSequence = false;
        }),
        filter(searchTerm => searchTerm != null),
        switchMap(() => {
          this.pagination.pageIndex = 0;
          this.DtoPagination.SortColumn = this.sort.active;
          this.DtoPagination.SortDirection = this.sort.direction;
          this.DtoPagination.SearchCol = this.commonService.searchText;

          return this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETMSSIDCPROPOSALDETAILS, this.DtoPagination)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp && resp.status) {
            this.length = resp.totalRecords;
            this.totalItems = resp.data.item1.totalCount;
            this.totalRegistered = resp.data.item1.totalCount;
            this.pendingVerification = resp.data.item1.pendingCount;
            this.approvedRegistration = resp.data.item1.approvedCount;
            this.rejectedRegistration = resp.data.item1.rejectedCount;
          }
          //console.log(resp?.data.item2);
          return resp?.data.item2 || {};
        })
      )
      .subscribe(data => {
        this.dataSource = data;
        this.adjustPaginator();
      });
  }

  ngOnDestroy() {
    this.loadDataSubscription.unsubscribe();
   this.loadWOESubscription.unsubscribe();
    this.rowUpdatedSubscription?.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }
  onClearForm() {
    // reset the reactive form
    this.workOrderExtForm.reset();

    // clear file input (important!)
    if (this['fileInput']) {
      this['fileInput'].nativeElement.value = '';
    }

    // clear local variables if any
    this.fileName = '';
    this.certificateFile = null;
    this.uploadError = null;
    this.fileUrl = null;
  }

  resetWOE() {
    this.workOrderExtForm.patchValue({
      fromDate: null,
      toDate: null,
      fileUpload: null,
      remark: null
    });

    // Clear validators + errors
    this.workOrderExtForm.get('fromDate')?.markAsPristine();
    this.workOrderExtForm.get('toDate')?.markAsPristine();
    this.workOrderExtForm.get('fileUpload')?.markAsPristine(); // reset clears value + errors
    this.workOrderExtForm.get('remark')?.markAsPristine();

    // Clear component-level variables
    this.fileName = '';
    this.certificateFile = null;
    this.fileUrl = null;
    sessionStorage.removeItem('storeFileName');
  }

  adjustPaginator() {
    const totalPages = Math.ceil(this.length / this.pageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPagination.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.pagination.pageIndex = this.pageIndex;
  }

  //LoadDetails() {
  //  //this.pageSize = 10;
  //  this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETMSSIDCPROPOSALDETAILS, this.DtoPagination).subscribe(
  //    result => {
  //      if (result.status) {
  //        var summary = result.data.item1;
  //        this.dataSource = result.data.item2;
  //        //console.log(this.dataSource);
  //        console.log(result.totalRecords);
  //        this.length = result.totalRecords;
  //        this.totalItems = summary["totalCount"];       
  //        this.totalRegistered = summary["totalCount"];
  //        this.pendingVerification = summary["pendingCount"];
  //        this.approvedRegistration = summary["approvedCount"];
  //        this.rejectedRegistration = summary["rejectedCount"];
  //      } else {

  //      }
  //    }
  //  )
  //}
  
  action(proposalUserId: string, action: string): void {
    // Implement approval logic here
    this.router.navigate(['/proposalverificationdetail', proposalUserId, action]);
  }

  verify(proposalUserId: number, action: string): void {
    // Implement rejection logic here
    this.router.navigate(['/proposalverificationdetail', proposalUserId, action]);
  }


  //sort(column: string): void {
  //  if (this.sortColumn === column) {
  //    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
  //  } else {
  //    this.sortColumn = column;
  //    this.sortDirection = 'asc';
  //  }
  //  this.updateSortedItems();
  //}

  //updateSortedItems(): void {
    
  //}


  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  pageIndex = 0;
  pageEvent!: PageEvent;

  onPageChange(e: PageEvent) {
    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;

    this.DtoPagination.PageNumber = e.pageIndex + 1;
    this.DtoPagination.PageSize = e.pageSize;
    this.LoadDetails();
  }


  //onPageChange(event: any) {
  //  this.DtoPagination.PageNumber = event.pageIndex + 1;
  //  this.DtoPagination.PageSize = event.pageSize;
  //  this.LoadDetails(this.DtoPagination);
  //}
  
  onSearchChange(e: any) {
    this.DtoPagination.SearchTerm = e.target.value;
    this.DtoPagination.PageNumber = 1;
    this.LoadDetails();
  }

  showOtherDetail(iaid: string): void {

    // Implement approval logic here
    sessionStorage.setItem("iaid", iaid);
    this.router.navigate(['/iaprofiledetails']);
    //this.router.navigate(['/msmeverificationdetails', msmeUserId, action]);

  }

  onSearchClick(searchValue: string): void {
    const searchControl = this.verifyProposalForm.get('search');
    searchControl?.markAsTouched();

    if (searchControl?.valid && searchValue.trim() !== '') {
      this.DtoPagination.SearchTerm = searchValue.trim();
      this.DtoPagination.SearchCol = this.commonService.searchText;
      this.LoadDetails();
    }
  }  

  resetPage() {
    this.DtoPagination.SearchTerm = "";
    this.DtoPagination.SearchCol = this.commonService.searchText;
    this.LoadDetails();
  }
  onDownload(filePath: string, fileName: string) {
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        console.error('Download failed:', error);
      }
    });
  }

  exportToExcel(): void {
    const fileName = 'MSSIDC_Proposal_Details.xlsx';

    const DtonullPagination = {
      PageNumber: 1,
      PageSize: 9999999,
      SortColumn: "",
      SortDirection: "",
      SearchTerm: this.commonService.searchText,
      SearchCol: ""
    };

    this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETMSSIDCPROPOSALDETAILS, DtonullPagination).subscribe(
      result => {
        if (result.status) {
          this.allrecord = result.data.item2;
        }

        if (!this.allrecord || this.allrecord.length === 0) {
          this.toastrService.error('No data available to export.');
          return;
        }

        // Prepare the data for export
        const excelData = this.allrecord.map((item, index) => ({
          'Sr. No': index + 1,
          'Proposal Id': item.proposalId,
          'IA Name': item.shortNameOfOrganisation,
          'Submission Date': item.dateOfSubmission,
          'Intervention': item.interventionName,
          'Component': item.componentName,
          'Status': item.status,
          'Status Date': item.statusDate,
          'Remarks': item.remarks,
          'Other Details': item.iaid,
          'Download Link': item.documentPath ? `Download ${item.documentName}` : ''
        }));

        // Create a worksheet
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

        // Auto-adjust column width
        worksheet['!cols'] = [
          { wch: 10 }, // Sr. No
          { wch: 15 }, // Proposal Id
          { wch: 25 }, // IA Name
          { wch: 20 }, // Submission Date
          { wch: 20 }, // Intervention
          { wch: 20 }, // Component
          { wch: 15 }, // Status
          { wch: 20 }, // Status Date
          { wch: 30 }, // Remarks
          { wch: 15 }, // Other Details
          { wch: 25 }  // Download Link
        ];

        // Create a workbook
        const workbook: XLSX.WorkBook = {
          Sheets: { 'Proposal Details': worksheet },
          SheetNames: ['Proposal Details']
        };

        // Generate a buffer for the Excel file
        const excelBuffer: any = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        });

        // Save the Excel file
        this.saveExcelFile(excelBuffer, fileName);
        this.toastrService.success('Excel exported successfully!');
      }
    );
  }

  // Reusable method to save Excel file
  saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs(data, fileName);
  }

  openFilePreviewDialog(filePath: string, fileName: string): void {

    //var filePath = this.form.get('documentPath')?.value;
    //var fileName = this.form.get('documentName')?.value;

    this.apiService.getFilePreview(filePath).subscribe({
      next: (fileUrl) => {
        const dialogRef = this.dialog.open(PreviewfileComponent, {
          width: '80%',
          height: '80',
          data: { fileUrl, fileName }
        });
      }
    });
  }

  //#region My Event Section
  woePageSizeOptions: number[] = [10, 20, 50, 100];  // Available page sizes
  woeLength: number = 0;
  woePageSize: number = 10;
  woeDisplayedData: any[] = [];
  woeHidePageSize = false;
  woeShowPageSizeOptions = true;
  woeShowFirstLastButtons = true;
  woeDisabled = false;
  woePageIndex = 0;
  woePageEvent!: PageEvent;

  onPageWOEChange(e: PageEvent) {
    debugger;
    this.woePageEvent = e;
    this.woeLength = e.length;
    this.woePageSize = e.pageSize;
    this.woePageIndex = e.pageIndex;

    this.DtoPaginationWOE.PageNumber = e.pageIndex + 1;
    this.DtoPaginationWOE.PageSize = e.pageSize;

    // Fetch new data when pagination changes
    this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETWORKORDEREXTENSIONDETAILS, this.DtoPaginationWOE)
      .pipe(catchError(() => of(null)))
      .subscribe(resp => {
        if (resp && resp.status) {
          this.dataSourceWorkOrderExtension = resp.data.item2;
          this.woeLength = resp.totalRecords;
        }
      });
  }

  dialogRef1!: MatDialogRef<any>;  // keep reference

  //onViewWorkOrderExtension(templateRef: TemplateRef<any>, proposalUserId: string, proposalId: string): void {
  //  debugger;
  //  this.loadingSequence = true;
  //  this.onClearForm();
  //  if (!this.paginationWOE) return;

  //  // 1. Prepare initial DTO parameters
  //  this.DtoPaginationWOE.proposalUserId = proposalUserId;
  //  this.proposalId = proposalId;
  //  this.DtoPaginationWOE.SortColumn = this.sort?.active;
  //  this.DtoPaginationWOE.SortDirection = this.sort?.direction;
  //  this.DtoPaginationWOE.SearchCol = this.commonService.searchText;
  //  this.paginationWOE.pageIndex = 0; // Reset page for initial load

  //  // Unsubscribe from any previous continuous stream
  //  this.loadWOESubscription.unsubscribe();

  //  // 2. Initial Data Fetch (Manual API Call - Runs ONCE)
  //  this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETWORKORDEREXTENSIONDETAILS, this.DtoPaginationWOE)
  //    .pipe(
  //      catchError(() => of(null)),
  //      finalize(() => {
  //        this.loadingSequence = false;
  //      })
  //    )
  //    .subscribe(resp => {
  //      if (resp && resp.status && resp.data) {

  //        // A. Open Dialog (Runs ONCE)
  //        this.dialogRef1 = this.dialog.open(templateRef, {
  //          data: { mode: 'Renew' },
  //          width: '1200vw',
  //          height: '80vh'
  //        });

  //        // B. Setup afterClosed Handler (Runs ONCE)
  //        this.dialogRef1.afterClosed().subscribe((result) => {
  //          // CRITICAL: Unsubscribe the continuous load stream when the dialog is closed.
  //          this.loadWOESubscription.unsubscribe();

  //          // Only reload the main grid if the submission was successful (result === true)
  //          if (result === true) {
  //            //this.LoadDetails(); // Reload the parent grid
  //            this.DtoPagination.PageSize = 20;
  //            this.DtoPagination.SearchTerm = this.commonService.searchText;
  //            this.LoadDetails();
  //          }
  //          window.scrollTo({ top: 0, behavior: 'smooth' });
  //          this.notCallingPopup();
  //        });

  //        // C. Patch Form Values (Runs ONCE)
  //        this.workOrderExtForm.patchValue({
  //          createdProposalId: resp.data.item1?.createdProposalId || null,
  //          shortNameOfOrganisation: resp.data.item1?.shortNameOfOrganisation || null,
  //          interventionName: resp.data.item1?.interventionName || null,
  //          interestName: resp.data.item1?.interestName || null,
  //          balanceTargetMSME: resp.data.item1?.balanceTargetMSME || null,
  //        });

  //        // D. Set Initial Table Data (Runs ONCE)
  //        this.woeLength = resp.totalRecords;
  //        this.dataSourceWorkOrderExtension = resp.data.item2;
  //        this.adjustEventPaginator();

  //        // E. Setup the Continuous Stream (Runs ONCE, then listens for clicks)
  //        this.setupWOELoadStream(proposalUserId);
  //      }
  //    });
  //}

  //// ⭐ NEW HELPER FUNCTION: This contains the MERGE stream for ongoing table events ⭐
  //setupWOELoadStream(proposalUserId: string): void {
  //  // Reset subscription with a new request
  //  this.loadWOESubscription = merge(
  //    this.sort?.sortChange.pipe(takeUntil(this.destroy$)),
  //    this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
  //    this.paginationWOE.page.pipe(takeUntil(this.destroy$))
  //  )
  //    .pipe(
  //      filter(trigger => trigger != null), // Filter out initial null trigger
  //      switchMap(() => {
  //        // Set loading for subsequent loads
  //        this.loadingSequence = true;

  //        // Update DTO with current sorting/searching/paging info
  //        this.DtoPaginationWOE.SortColumn = this.sort?.active;
  //        this.DtoPaginationWOE.SortDirection = this.sort?.direction;
  //        this.DtoPaginationWOE.SearchCol = this.commonService.searchText;
  //        this.DtoPaginationWOE.proposalUserId = proposalUserId; // Keep ID set

  //        return this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETWORKORDEREXTENSIONDETAILS, this.DtoPaginationWOE)
  //          .pipe(
  //            catchError(() => of(null)),
  //            finalize(() => this.loadingSequence = false)
  //          );
  //      }),
  //      map(resp => {
  //        if (resp && resp.status) {
  //          this.woeLength = resp.totalRecords;
  //          // Only return the table data (item2) for subsequent updates
  //          return resp?.data?.item2 || [];
  //        }
  //        return [];
  //      })
  //    )
  //    .subscribe(data => {
  //      // Only update the table data and paginator for sorting/pagination events
  //      this.dataSourceWorkOrderExtension = data;
  //      this.adjustEventPaginator();
  //    });
  //}
  onViewWorkOrderExtension(templateRef: TemplateRef<any>, proposalUserId: string, proposalId: string): void {
    this.loadingSequence = true;
    this.onClearForm();
    if (!this.paginationWOE) return;
    // Unsubscribe from previous subscription to prevent multiple API calls
    this.loadWOESubscription.unsubscribe();
    // Reset subscription with a new request
    this.loadWOESubscription = merge(
      this.sort?.sortChange.pipe(takeUntil(this.destroy$)),
      this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
      this.paginationWOE.page.pipe(takeUntil(this.destroy$))
    )
      .pipe(
        finalize(() => {
          this.loadingSequence = false;
        }),
        filter(searchTerm => searchTerm != null),
        switchMap(() => {
          this.paginationWOE.pageIndex = 0;
          this.DtoPaginationWOE.SortColumn = this.sort?.active;
          this.DtoPaginationWOE.SortDirection = this.sort?.direction;
          this.DtoPaginationWOE.SearchCol = this.commonService.searchText;
          this.DtoPaginationWOE.proposalUserId = proposalUserId;

          return this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETWORKORDEREXTENSIONDETAILS, this.DtoPaginationWOE)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp && resp.status) {
            debugger;
            this.dialogRef1 = this.dialog.open(templateRef, {
              data: { mode: 'Renew' },
              width: '1200vw',
              height: '80vh'
            });
            // CRITICAL: Setup the afterClosed handler here, once.
            this.dialogRef1.afterClosed().subscribe((result) => {
              // Unsubscribe the continuous load stream when the dialog is closed.
              this.loadWOESubscription.unsubscribe();

              this.rowUpdateService.emitRowUpdate();
              window.scrollTo({ top: 0, behavior: 'smooth' });
              this.notCallingPopup();
            });
            this.woeLength = resp.totalRecords;

            this.workOrderExtForm.patchValue({
              createdProposalId: resp?.data?.item1?.createdProposalId || null,
              shortNameOfOrganisation: resp?.data?.item1?.shortNameOfOrganisation || null,
              interventionName: resp?.data?.item1?.interventionName || null,
              interestName: resp?.data?.item1?.interestName || null,
              balanceTargetMSME: resp?.data?.item1?.balanceTargetMSME || null,
            });

            this.proposalId = proposalId;
            this.woeLength = resp.totalRecords;
            return resp?.data || {};
          }
        })
      )
      .subscribe(data => {
        this.dataSourceWorkOrderExtension = data.item2;
        this.adjustEventPaginator();
      });

  }

  onViewHistory(templateRef: TemplateRef<any>, proposalUserId: string): void {
    // 1. Setup/Cleanup
    this.loadingSequence = true;

    // Clear the *Renew* form fields, though they won't be shown in 'View' mode, 
    // it's good practice to keep the main form state clean.
    this.onClearForm();

    if (!this.paginationWOE) return;

    // Unsubscribe from previous *renewal* subscription
    this.loadWOESubscription.unsubscribe();

    // Unsubscribe from previous *history* subscription if you define a separate one
    // this.loadHistorySubscription.unsubscribe(); 

    // Reset subscription with a new request to load history data
    this.loadWOESubscription = merge(
      this.sort?.sortChange.pipe(takeUntil(this.destroy$)),
      this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
      this.paginationWOE.page.pipe(takeUntil(this.destroy$))
    )
      .pipe(
        finalize(() => {
          this.loadingSequence = false;
        }),
        filter(searchTerm => searchTerm != null),
        switchMap(() => {
          this.paginationWOE.pageIndex = 0;
          this.DtoPaginationWOE.SortColumn = this.sort?.active;
          this.DtoPaginationWOE.SortDirection = this.sort?.direction;
          this.DtoPaginationWOE.SearchCol = this.commonService.searchText;
          // Use the correct ID for fetching history
          this.DtoPaginationWOE.proposalUserId = proposalUserId;

          return this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETWORKORDEREXTENSIONDETAILS, this.DtoPaginationWOE)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp && resp.status) {
            console.log(resp.data);

            // 2. Open Dialog and Pass Mode: 'View'
            this.dialogRef1 = this.dialog.open(templateRef, {
              data: { mode: 'View' }, // ⭐ Passes 'View' to hide the form ⭐
              width: '1200vw',
              height: '80vh',
              // Pass the data context object with the 'mode' flag
              
            });

            this.dialogRef1.afterClosed().subscribe(() => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
              this.notCallingPopup();
            });

            this.woeLength = resp.totalRecords;
            // NOTE: We intentionally SKIP the workOrderExtForm.patchValue() call here

            return resp?.data || {};
          }
        })
      )
      .subscribe(data => {
        this.dataSourceWorkOrderExtension = data.item2;
        this.adjustEventPaginator();
      });
  }


  adjustEventPaginator() {
    const totalPages = Math.ceil(this.woeLength / this.woePageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.woePageIndex >= totalPages) {
      this.woePageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPaginationWOE.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.paginationWOE.pageIndex = this.woePageIndex;
  }

  notCallingPopup() {
    this.loadDataSubscription.unsubscribe();
    this.loadWOESubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  onClosePopup() {
    this.DtoPaginationWOE.PageNumber = 1;
    this.woePageIndex = 0;  // Reset event page index
    this.paginationWOE.pageIndex = 0;  // Reset pagination event index    
  }

  onDateChange(): void {
    // when user selects a date, reset today/tomorrow buttons
    this.workOrderExtForm.patchValue({
      today: false,
      tomorrow: false
    });

    // Optional: check validity immediately
    const from = this.workOrderExtForm.get('fromDate')?.value;
    const to = this.workOrderExtForm.get('toDate')?.value;

    if (from && to && from > to) {
      this.workOrderExtForm.setErrors({ dateRangeInvalid: true });
    } else {
      // clear error if valid
      if (this.workOrderExtForm.hasError('dateRangeInvalid')) {
        this.workOrderExtForm.setErrors(null);
      }
    }
  }
  onUploadProposalFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    // Reset previous values
    this.uploadError = null;
    this.fileName = '';
    this.certificateFile = null;
    this.workOrderExtForm.get('fileUpload')?.reset(); // ✅ reset FormControl

    // File is required
    if (!file) {
      this.uploadError = 'Please upload a file.';
      this.workOrderExtForm.get('fileUpload')?.setErrors({ required: true });
      return;
    }

    // Validate file type (Only PDF)
    if (file.type !== 'application/pdf') {
      this.uploadError = 'Only PDF files are allowed.';
      this.toastrService.error('Only PDF files are allowed.', 'Validation Error');
      this.workOrderExtForm.get('fileUpload')?.setErrors({ invalidType: true });
      return;
    }

    // Validate file size (Max 10MB)
    const maxSizeInMB = 10;
    const fileSizeInMB = file.size / (1024 * 1024);
    if (fileSizeInMB > maxSizeInMB) {
      this.uploadError = 'File size should not exceed 10 MB.';
      this.toastrService.error('File size should not exceed 10 MB.', 'Validation Error');
      this.workOrderExtForm.get('fileUpload')?.setErrors({ maxSize: true });
      return;
    }

    // If valid, update values
    this.certificateFile = file;
    this.fileName = file.name;

    // ✅ update FormControl with selected file
    this.workOrderExtForm.get('fileUpload')?.setValue(file);
    this.workOrderExtForm.get('fileUpload')?.updateValueAndValidity();

    // Revoke old object URL if exists
    if (this.fileUrl) {
      URL.revokeObjectURL(this.fileUrl);
    }

    // Create new object URL for preview
    this.fileUrl = URL.createObjectURL(file);

    // Store only file name (not blob URL) in session storage
    sessionStorage.setItem('storeFileName', this.fileName);
  }

  openFile() {
    if (this.fileUrl) {
      window.open(this.fileUrl, "_blank");
    } else {
      alert("No file uploaded or invalid file!");
    }
  }

  prepareFormData(): FormData {
    const formData = new FormData();
    // Append values from verifyproposal form
    Object.keys(this.workOrderExtForm.value).forEach(key => {
      let value = this.workOrderExtForm.get(key)?.value;
      // Format dateOfIncorporation before appending
      if (key === 'fromDate' && value) {
        value = this.datePipe.transform(value, 'yyyy-MM-dd'); // Format date to YYYY-MM-DD
      }

      if (key === 'toDate' && value) {
        value = this.datePipe.transform(value, 'yyyy-MM-dd'); // Format date to YYYY-MM-DD
      }

      if (value !== null) {
        formData.append(key, value);
      }
    });

    const obj = {
      fileUpload: this.certificateFile,
      remark: this.workOrderExtForm.get('remark')?.value
    };

    // Append JSON data as a string
    formData.append('data', JSON.stringify(obj));

    // Append file if available
    if (this.certificateFile) {
      formData.append('fileUpload', this.certificateFile);
      formData.append('proposalId', this.proposalId);
      formData.append('proposalUniqueId', this.DtoPaginationWOE.proposalUserId);
    }
    return formData;
  }

  submitWOE(): void {
    const balance = this.workOrderExtForm.get('balanceTargetMSME')?.value;

    if (balance <= 0) {
      this.toastrService.error('Balance Target MSME must be greater than 0 to submit.');
      return;
    }

    this.loadingSequence = true;
    if (this.workOrderExtForm.invalid) {
      this.workOrderExtForm.markAllAsTouched();
      return;
    }

    const formData = this.prepareFormData();

    this.apiService.postRequest(API_ENDPOINTS.MSSIDC.POSTWORKORDEREXTENSION, formData
    ).pipe(
      finalize(() => {
        this.loadingSequence = false;
      })
    ).subscribe({
      next: (res: any) => {
        if (res.status) {
          this.LoadDetails(); // ⭐ Call LoadDetails ONLY if submission succeeded ⭐
          this.toastrService.success(res.message, "ExtensionID: " + res.data);
          this.dialogRef1.close(true);
        }
        else {
          this.toastrService.error(res.message);
        }
      },
      error: (err: any) => {
        console.error('An error occurred during Work Order Form Submit:', err);
        this.toastrService.error('An error occurred, please try again.');
      }
    });
  }
  today: number = new Date().setHours(0, 0, 0, 0);
  // chnage given by harshal on 23-04-2026
  // isRenewEnabled(toDate: string | Date): boolean {
  //   if (!toDate) return false; // safeguard

  //   const today = new Date();
  //   const endDate = new Date(toDate);

  //   // Enable only if today's date is after the toDate
  //   return today > endDate;
  // }

  //



isExpired(dateStr: string): boolean {
  if (!dateStr) return false;

  const [day, month, year] = dateStr.split('/');

  const date = new Date(+year, +month - 1, +day);
  const today = new Date();

  today.setHours(0, 0, 0, 0);
  date.setHours(0, 0, 0, 0);

  console.log('Parsed:', { dateStr, parsed: date, today });

  return date < today;
}

  //   isRenewEnabled(toDate: string | Date): boolean {
  //   if (!toDate) return false; // safeguard

  //   const today = new Date();
  //   const endDate = new Date(toDate);

  //   // Enable only if today's date is after the toDate
  //   return today > endDate;
  // }
  //#endregion

}
